import { API_URL } from './config';

export async function getOrderAll(authToken, table, id) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/order/all/${table}/${id}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching');
  }
  return await res.json();
}

export async function getOrderDetails(authToken, id) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/order/${id}`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching');
  }
  return await res.json();
}

export async function getOrderAllData(authToken) {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/order/all/list`, {
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-Type': 'application/json'
    }
  });
  if (res.status === 401) {
    throw new Error('Not authorized. Please sign in');
  }
  if (res.status !== 200) {
    throw new Error('Error fetching');
  }
  return await res.json();
}

export const postOrder = async (
  authToken,
  postedTable,
  postedTableId,
  data
) => {
  if (!authToken) {
    return;
  }

  const res = await fetch(`${API_URL}/order`, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-type': 'Application/json'
    },
    body: JSON.stringify({
      additionalFields: [data],
      postedTable: postedTable,
      postedTableId: postedTableId
    })
  });
  if (res.status === 400) {
    throw new Error('Error during posting.');
  } else {
    return res.json();
  }
};

export async function updateOrder(authToken, id, data, status) {
  if (!authToken) {
    return;
  }
  // console.log(JSON.stringify(data))

  const res = await fetch(`${API_URL}/order/${id}`, {
    method: 'PUT',
    headers: {
      Authorization: `Bearer ${authToken}`,
      'Content-type': 'application/json' // "application/json" should be lowercase
    },
    body: JSON.stringify({
      additionalFields: [data],
      status: status
    }) // Convert data to JSON string
  });

  if (res.status === 400) {
    throw new Error('Failed to update the user. Try again!');
  }

  return await res.json();
}
